module.exports = __webpack_public_path__ + "img/Czechia_GP2_picture2.0c8d952b.webp";